export default {
  reviewStatistics:
    "dashboard/REVIEW_CU/ReviewStatsManager_getReviewStatistics",
  dateStatistics: "dashboard/REVIEW_CU/ReviewStatsManager_getDateStatistics",
  reviewLogs: "dashboard/reviewLogs",
  licenseCategory:
    "dashboard/REVIEW_CU/ReviewStatsManager_getLicenseCategoryStats",
};
